import { Injectable } from '@angular/core';
import { HttpWrapperService } from '../common/http-wrapper/http-wrapper.service';
import { Observable } from 'rxjs';
import { EmailDistributionFilterModel } from '../../../../api/amplify/model/amplify-request.model';
import { AmplifyStoryResultModel } from '../../../../api/amplify/model/amplify-unified.model';
import { StoryModel } from '../../../../api/amplify/model/amplify-reponse.model';

@Injectable()
export class AgilityApiService {

    constructor(private httpService: HttpWrapperService ) { }

    public getDistImage(url: string): Observable<Blob> {
        return this.httpService.agilityEmailDistGetImage<Blob>(url);
    }

}
